export default __webpack_public_path__ + "static/media/totalEarnedInvoice.bf99f4af.svg";